function numberRight(element: Element): number | undefined {
  let right: number | undefined;
  const walker = element.ownerDocument.createTreeWalker(element, 4);
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    if (!/\d/.test(node.textContent || '')) continue;
    const range = element.ownerDocument.createRange();
    range.selectNodeContents(node);
    if (typeof range.getBoundingClientRect !== 'function') continue;
    const rect = range.getBoundingClientRect();
    if (rect.width > 0) right = Math.max(right ?? rect.right, rect.right);
  }
  return right;
}

/** Anchor summaries to the visible values in the worksheet's last column. */
export function alignClientDocumentSummaries(root: HTMLElement) {
  const table = root.querySelector('table');
  if (!table) return;
  let amountRight: number | undefined;
  table.querySelectorAll('tbody > tr:not([data-document-total]):not([data-quote-summary-row])').forEach(row => {
    const right = row.lastElementChild && numberRight(row.lastElementChild);
    if (right !== null && right !== undefined) amountRight = Math.max(amountRight ?? right, right);
  });
  root.querySelectorAll<HTMLElement>('[data-client-summary-group]').forEach(group => {
    const amount = group.querySelector('[data-client-summary-value]');
    if (!amount) return;
    const current = parseFloat(group.style.getPropertyValue('--client-summary-inset')) || 0;
    const unshiftedRight = (numberRight(amount) ?? amount.getBoundingClientRect().right) + current;
    const inset = amountRight === undefined ? 0 : unshiftedRight - amountRight;
    const value = `${inset.toFixed(2)}px`;
    if (group.style.getPropertyValue('--client-summary-inset') !== value) group.style.setProperty('--client-summary-inset', value);
  });
}
